import React from 'react';

const TagAt = ({ width = 20, height = 20, color = 'var(--icon-default)', ...rest }, ref) => {
  return (
    <svg
      {...rest}
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 10.6013 14.8939 11.1777 14.6993 11.7117C14.6292 11.9041 14.5062 12.0717 14.3557 12.2106L14.2886 12.2725C13.8259 12.6994 13.1311 12.7541 12.6073 12.4049C12.2279 12.1519 12 11.7261 12 11.2701V10M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M1.66675 9.99935C1.66675 5.39698 5.39771 1.66602 10.0001 1.66602C14.6025 1.66602 18.3334 5.39698 18.3334 9.99935C18.3334 14.6017 14.6025 18.3327 10.0001 18.3327C5.39771 18.3327 1.66675 14.6017 1.66675 9.99935Z"
        stroke={color}
        strokeWidth="1.25"
      />
    </svg>
  );
};

export default React.forwardRef(TagAt);
